import axios from '../plugins/axios.js';

export default {
    async sso(payload = {}) {
        const response = await axios.get('v1/exp/sso', payload);

        return response.data.token;
    },
};
